import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ListItem } from '@fs/zion-ui'
import { ControlDrag } from '@fs/zion-icon'
import {
  getPersonName,
  getPrimaryRelationshipText,
  getRelationshipToPrimaryPersonDisplayLabel,
  getRelationshipToPrimaryPersonText,
  useSlsStateContext,
} from '@fs/zion-sls'
import Draggable, { dashedBorderCssStyle } from '../../../../../views/indexing/components/ui/Draggable'

const dragControlCss = css`
  user-select: none;

  & li svg {
    touch-action: none;
    cursor: grab;
  }
`

export const PersonListItemDisplay = ({ person, record, t }) => {
  const zionSlsState = useSlsStateContext()

  const personName = getPersonName({ person })
  const primaryRelationshipLabel = getRelationshipToPrimaryPersonDisplayLabel(person, zionSlsState.types, record)
  const relationshipText = getRelationshipToPrimaryPersonText(person, zionSlsState.types, record, t)
  const primaryRelationshipText = getPrimaryRelationshipText(primaryRelationshipLabel, relationshipText)

  return (
    <div css={dragControlCss}>
      <ListItem
        data-testid={`edit-household-person-${person?.id}`}
        overline={record && primaryRelationshipText}
        primaryText={personName}
        emphasized={record && !!person?.primary}
        endElement={<ListItem.Icon title={t('edit-household.drag-handle', 'Drag to reorder')} Icon={ControlDrag} />}
      />
    </div>
  )
}

const PersonListItem = ({ person, record, dragInfo }) => {
  const [t] = useTranslation()

  const isDragging = dragInfo?.isDragging && dragInfo?.person?.id === person?.id
  const draggableStyle = {
    overflow: 'hidden',
    borderRadius: '0.25rem',
    paddingLeft: '4px',
    ...(isDragging ? dashedBorderCssStyle : {}),
  }

  return (
    <Draggable
      id={person?.id}
      style={draggableStyle}
      data={{ person, record }}
      testId={`draggable-person-${person?.id}`}
    >
      <PersonListItemDisplay person={person} record={record} t={t} />
    </Draggable>
  )
}

export default PersonListItem
